import React from "react";
import { GoStop } from "react-icons/go";
// import { MdOutlineGroups } from "react-icons/md";
import { AiOutlineAudit } from "react-icons/ai";
import { FaChalkboardTeacher } from "react-icons/fa";
// import { TbReportMedical } from "react-icons/tb";
// import { GoStop } from "react-icons/go";
import CheckIcon from "app/Components/_checkIcon/CheckIcon";
import { useHistory } from "react-router-dom";

import { icon } from "leaflet";
export function AuditMeetingWidgets(props) {
  return (
    <div className="row justify-content-center">
      <WidgetItem
        colClass="col-md-3"
        header="Internal Audits"
        value={props.internalAudit}
      />
      <WidgetItem
        colClass="col-md-3"
        header="External Audits"
        value={props.externalAudit}
      />
      <WidgetItem colClass="col-md-3" header="Meetings" value={props.meetings} />
      <WidgetItem colClass="col-md-3" header="CAPA Assigned" value={props.CAPAAssigned} />
      <WidgetItem
        colClass="col-md-3"
        header="CAPA Outstanding"
        value={props.CAPAOutstanding}
      />
    </div>
  );
}

export function IncidentWidgets({ isFilterClick, widgetData }) {
  return (
    <div className="row justify-content-center">
      {Object.values(widgetData)?.map((item, idx) => (
        <WidgetItem
          key={idx}
          colClass={isFilterClick ? "col-md-4" : "col-md-3"}
          header={item?.name}
          value={item?.value}
        />
      ))}
    </div>
  );
}

export function WidgetCard({ isFilterClick, widgetData, className }) {
  return (
    <div className="row justify-content-center">
      {widgetData?.map((item, idx) => (
        <WidgetItem
          key={idx}
          colClass={className ? className : isFilterClick ? "col-md-4" : "col-md-3"}
          header={item?.name}
          value={item?.value ? item.value : 0}
          icon={item?.icon}
          link={item?.link}
        />
      ))}
    </div>
  );
}

export function ComplianceRegisterWidgets(props) {
  return (
    <div className="row justify-content-center">
      <WidgetItem
        colClass="col-md-4"
        header="Compliance expiring in next 30 days"
        value={props.complianceExpiringInNext30days}
      />
      <WidgetItem
        colClass="col-md-4"
        header="Compliances Expired"
        value={props.complianceExpired}
      />
      {/* <WidgetItem colClass="col-md-4" header="Compliances Expired" value={20} /> */}
    </div>
  );
}

export function CapaWidgets(props) {
  return (
    <div className="row justify-content-center">
      <WidgetItem colClass="col-md-4" header="CAPA Assigned" value={props.CAPAAssigned} />
      <WidgetItem
        colClass="col-md-4"
        header="CAPA Completed"
        value={props.CAPACompleted}
      />
      <WidgetItem
        colClass="col-md-4"
        header="CAPA Outstanding"
        value={props.CAPAOutstanding}
      />
    </div>
  );
}

export function WorkPermitWidgets(props) {
  return (
    <div className="row justify-content-center">
      <WidgetItem colClass="col-md-3" value={props.requestedWP} header="Requested" />
      <WidgetItem colClass="col-md-3" value={props.issuedWP} header="Issued" />
      <WidgetItem colClass="col-md-3" value={props.rejectedWP} header="Rejected" />
      <WidgetItem colClass="col-md-3" value={props.renewedWP} header="Renewed" />
      <WidgetItem colClass="col-md-3" value={props.closedWP} header="Closed" />
      <WidgetItem colClass="col-md-3" value={props.escalatedWP} header="Escalated" />
      <WidgetItem colClass="col-md-3" value={props.blanketWP} header="Blanket" />
      <WidgetItem
        colClass="col-md-3"
        value={props.roundtheClockWP}
        header="Round the Clock"
      />
      <WidgetItem
        colClass="col-md-3"
        value={props.holidaysSundaysWP}
        header="Holidays & Sundays"
      />
      <WidgetItem
        colClass="col-md-3"
        value={props.afterWorkingHoursWP}
        header="After Working Hours"
      />
      <WidgetItem
        colClass="col-md-3"
        value={props.multipleShiftsWP}
        header="Multiple Shifts"
      />
      <WidgetItem colClass="col-md-3" value={props.HWP} header="HWP" />
      <WidgetItem colClass="col-md-3" value={props.CWP} header="CWP" />
      <WidgetItem
        colClass="col-md-3"
        value={props.confinedSpaceWP}
        header="Confined Space"
      />
      <WidgetItem
        colClass="col-md-3"
        value={props.electricalIsolationWP}
        header="Electrical Isolation"
      />
      <WidgetItem
        colClass="col-md-3"
        value={props.workingAtHeightWP}
        header="Working at Height"
      />
      <WidgetItem colClass="col-md-3" value={props.others} header="Others" />
    </div>
  );
}

export function TrainingWidgets({ trainingsCount, participantsCount, averageFeedback }) {
  return (
    <div className="row justify-content-center">
      <WidgetItem colClass="col-md-4" header="Trainings" value={trainingsCount} />
      <WidgetItem colClass="col-md-4" header="Participants" value={participantsCount} />
      <WidgetItem colClass="col-md-4" header="Average Feedback" value={averageFeedback} />
    </div>
  );
}

export function VflWidgets({ isFilterClick, widgetData }) {
  return (
    <div className="row justify-content-center">
      {Object.values(widgetData)?.map((item, idx) => (
        <WidgetItem
          key={idx}
          colClass={isFilterClick ? "col-md-4" : "col-md-3"}
          header={item?.name}
          value={item?.value}
          icon={item?.icon}
        />
      ))}
    </div>
  );
}

function WidgetItem({ header, value, iconClassName, colClass, icon, link }) {
  const history = useHistory();
  return (
    <div
      className={colClass ? colClass + " pb-3" : "col-md-2  pb-3"}
      onClick={() => history.push(link)}
    >
      <div className="card card-icon-bg mb-3 customWidgets ehswidgets">
        <div className="card-body text-center">
          <CheckIcon icon={icon} classIs="largeIcons" />
          {/* <i className="i-Engineering"></i> */}
          <div className="content">
            <p style={{ width: "160px" }}>{header}</p>
            <h4>{value}</h4>
          </div>
        </div>
      </div>
    </div>
  );
}
